import { render, staticRenderFns } from "./ConnectionItem.vue?vue&type=template&id=886e2d52&"
import script from "./ConnectionItem.vue?vue&type=script&lang=js&"
export * from "./ConnectionItem.vue?vue&type=script&lang=js&"
import style0 from "./integrationMSTeamsCommonStyles.less?vue&type=style&index=0&module=true&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./integrationMSTeamsCommonStyles.less?vue&type=style&index=0&module=true&lang=css&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./integrationMSTeamsCommonStyles.less?vue&type=style&index=0&module=true&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("886e2d52")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('886e2d52')) {
      api.createRecord('886e2d52', component.options)
    } else {
      api.reload('886e2d52', component.options)
    }
    module.hot.accept("./ConnectionItem.vue?vue&type=template&id=886e2d52&", function () {
      api.rerender('886e2d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/integration/msteams/components/ConnectionItem.vue"
export default component.exports